"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgIgi = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 35.703,
  height: 17.855,
  ...props,
  children: (0, jsx_runtime_1.jsxs)("g", {
    "data-name": "Group 831",
    children: [(0, jsx_runtime_1.jsx)("g", {
      "data-name": "Group 788",
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 461",
        d: "M5.916 15.236l-.02-12.61L8.3 2.623l.02 12.608z"
      })
    }), (0, jsx_runtime_1.jsx)("g", {
      "data-name": "Group 833",
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 461",
        d: "M27.405 15.236l-.02-12.61 2.403-.004.02 12.608z"
      })
    }), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 545",
      d: "M23.85 6.257l-2.888.006a5.844 5.844 0 00-.702-.735 3.935 3.935 0 00-.743-.458 4.617 4.617 0 00-1.99-.467 4.551 4.551 0 00-3.86 2.156 4 4 0 00.031 4.266 4.673 4.673 0 001.69 1.6 4.492 4.492 0 002.26.596 4.263 4.263 0 002.903-1.14 4.4 4.4 0 00.922-1.146l-5.439.01-.004-2.19 8.478-.018.002.268a6.023 6.023 0 01-.919 3.247 6.642 6.642 0 01-2.504 2.36 7.135 7.135 0 01-3.47.872 7.148 7.148 0 01-3.49-.867 6.724 6.724 0 01-2.54-2.378 6.148 6.148 0 01-.948-3.277 6.229 6.229 0 01.925-3.31 6.762 6.762 0 012.525-2.418 7.013 7.013 0 013.46-.894 7.159 7.159 0 011.818.234 7.321 7.321 0 011.725.69 7.061 7.061 0 011.475 1.092 7.177 7.177 0 011.282 1.9z"
    })]
  })
});
exports.default = SvgIgi;